<ndt-extension-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [showExtensionRegisterPopup]="showExtensionRegisterPopup$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [showCreate]="false"
   [hideHeader]="true"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
>
</ndt-extension-register-view>
